import apiService from '../../../services/api-client';
import { GetMetricsParams, GetMetricsResponse } from '../interfaces/get-metrics';
import { PostMetricTypePayloadRequest, PostMetricTypeResponse } from '../../metrics/interfaces/post-metric-type';
import { GetMetricTypesResponse } from '../../metrics/interfaces/get-metric-types';
import { PutMetricTypePayloadRequest, PutMetricTypeResponse } from '../../metrics/interfaces/put-metric-type';
import { DeleteMetricTypeResponse } from '../../metrics/interfaces/delete-metric-type';
import { PostMetricsPayloadRequest } from '../interfaces/post-metrics';
import { GetGraphTypesResponse } from '../interfaces/get-graph-types';
import { PutGraphTypePayloadRequest, PutGraphTypeResponse } from '../interfaces/put-graph-type';
import { Metrics } from '../../../interfaces/metrics.interface';
import { MetricType } from '../../../interfaces/metricType.interface';

export const metricsApiService = {
  async getMetrics(id: string, params: GetMetricsParams) {
    const { data } = await apiService().get<Metrics>(
      `metrics/${id}`,
      { params },
    );

    return data;
  },
  async getMetricTypes(id: string) {
    const { data } = await apiService().get<MetricType[]>(`metrics/${id}/metric-types`);
    return data;
  },
  async getGraphTypes(id: string) {
    const { data } = await apiService().get<GetGraphTypesResponse>(`metrics/${id}/graph-types`);
    return data;
  },
  async postMetrics(id: string, body: PostMetricsPayloadRequest) {
    const formData = new FormData();
    for (const file of body.files) {
      formData.append('files', file);
    }

    const { data } = await apiService().post<PostMetricTypeResponse>(
      `metrics/${id}/import`,
      formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
    );
    return data;
  },
  async postMetricType(id: string, body: PostMetricTypePayloadRequest) {
    const { data } = await apiService().post<PostMetricTypeResponse>(`metrics/${id}/metric-types`, body);
    return data;
  },
  async putMetricType(id: string, mid: string, body: PutMetricTypePayloadRequest) {
    console.log(body)
    const { data } = await apiService().put<PutMetricTypeResponse>(`metrics/${id}/metric-types/${mid}`, body);
    return data;
  },
  async putGraphType(id: string, mid: string, body: PutGraphTypePayloadRequest) {
    const { data } = await apiService().put<PutGraphTypeResponse>(`metrics/${id}/graph-types/${mid}`, body);
    return data;
  },
  async deleteMetricType(id: string, mid: string) {
    const { data } = await apiService().delete<DeleteMetricTypeResponse>(
      `metrics/${id}/metric-types/${mid}`
    );
    return data;
  },
  async getDailySummary(companyId: string, integrationPrefix: string, startDate: string, endDate: string) {
    const { data } = await apiService().get(
      `${integrationPrefix}/${companyId}/daily-summary`,
      { params: { start_date: startDate, end_date: endDate } }
    );
    return data;
  },
};
